import { Activity } from '@/Domain/Activities'

export class ActivityDto {
  private _code: string
  private _name: string

  public static fromActivity (activity: Activity): ActivityDto {
    return new this(
      activity.code(),
      activity.code() + ' - ' + activity.name()
    )
  }

  constructor (code: string, name: string) {
    this._code = code
    this._name = name
  }

  get code (): string {
    return this._code
  }

  get name (): string {
    return this._name
  }
}
